import { SystemOptionType } from 'data/types';
import { systemOptionSortMetrics } from 'utils/system-option-sort-metrics';
import { sortBySystemSortOption, SystemSortOption } from 'utils/system-sort';
import { PickKind, TopPicks } from './equipment-comparison-utils';

export type DuctlessGridItem = {
  system: SystemOptionType;
  kind: PickKind | null;
  systemNumber?: number;
};

export const PICK_ORDER: PickKind[] = [
  'bestOverall',
  'bestComfort',
  'lowestCost',
  'easiestInstall',
  'quietestOperation'
];

type DuctlessGridItemsInput = {
  customSystems: SystemOptionType[];
  picks: TopPicks;
  moreSystems: SystemOptionType[];
  showMore: boolean;
  systemNumberById: ReadonlyMap<string, number>;
};

export const buildDuctlessGridItems = ({
  customSystems,
  picks,
  moreSystems,
  showMore,
  systemNumberById
}: DuctlessGridItemsInput): DuctlessGridItem[] => {
  const customItems = customSystems.map((system) => ({ system, kind: null }));
  const pickItems = PICK_ORDER.flatMap((kind) => {
    const system = picks[kind];
    return system ? [{ system, kind }] : [];
  });
  const moreItems = showMore
    ? moreSystems.map((system) => ({
        system,
        kind: null,
        systemNumber: systemNumberById.get(system.id)
      }))
    : [];
  return [...customItems, ...pickItems, ...moreItems];
};

export const orderDuctlessGridItems = (
  items: DuctlessGridItem[],
  sort: SystemSortOption
): DuctlessGridItem[] =>
  sortBySystemSortOption(items, sort, (item) =>
    systemOptionSortMetrics(item.system)
  );
